import { Data } from "@/App";
let data: Data[] = [
  {
    id: 0,
    title: "페그 BLACK",
    price: 109000,
    imgUrl: "/img/section01_product001_front.jpg",
    imgUrlSub: "/img/section01_product001_back.jpg",
    imgUrlDetail1: "/img/SubImg/section01_product001_detail01.jpg",
    imgUrlDetail2: "/img/SubImg/section01_product001_detail02.jpg",
    imgUrlDetail3: "/img/SubImg/section01_product001_detail03.jpg",
    imgUrlDetail4: "/img/SubImg/section01_product001_detail04.jpg",
    imgUrlDetail5: "",
    imgUrlDetailCleaning: "/img/SubImg/detail_cleaning_shoes.jpg",
    alt: "페그 BLACK",
  },
  {
    id: 1,
    title: "케이 마이크로플리스 안감형 자켓 BLACK",
    price: 219000,
    imgUrl: "/img/section01_product002_front.jpg",
    imgUrlSub: "/img/section01_product002_back.jpg",
    imgUrlDetail1: "/img/SubImg/section01_product002_detail01.jpg",
    imgUrlDetail2: "/img/SubImg/section01_product002_detail02.jpg",
    imgUrlDetail3: "/img/SubImg/section01_product002_detail03.jpg",
    imgUrlDetail4: "/img/SubImg/section01_product002_detail04.jpg",
    imgUrlDetail5: "/img/SubImg/section01_product002_detail05.jpg",
    imgUrlDetailCleaning: "/img/SubImg/detail_cleaning_mtm.jpg",
    alt: "케이 마이크로플리스 안감형 자켓 BLACK",
  },
  {
    id: 2,
    title: "레터링 릴렉스핏 볼캡 BLACK",
    price: 45000,
    imgUrl: "/img/section01_product003_front.jpg",
    imgUrlSub: "/img/section01_product003_back.jpg",
    imgUrlDetail1: "/img/SubImg/section01_product003_detail01.jpg",
    imgUrlDetail2: "/img/SubImg/section01_product003_detail02.jpg",
    imgUrlDetail3: "/img/SubImg/section01_product003_detail03.jpg",
    imgUrlDetail4: "/img/SubImg/section01_product003_detail04.jpg",
    imgUrlDetail5: "/img/SubImg/section01_product003_detail05.jpg",
    imgUrlDetailCleaning: "/img/SubImg/detail_cleaning_cap.jpg",
    alt: "레터링 릴렉스핏 볼캡 BLACK",
  },
  {
    id: 3,
    title: "에센셜 시그니처 로고 맨투맨 MELANGE GREY",
    price: 99000,
    imgUrl: "/img/section01_product004_front.jpg",
    imgUrlSub: "/img/section01_product004_back.jpg",
    imgUrlDetail1: "/img/SubImg/section01_product004_detail01.jpg",
    imgUrlDetail2: "/img/SubImg/section01_product004_detail02.jpg",
    imgUrlDetail3: "/img/SubImg/section01_product004_detail03.jpg",
    imgUrlDetail4: "/img/SubImg/section01_product004_detail04.jpg",
    imgUrlDetail5: "",
    imgUrlDetailCleaning: "/img/SubImg/detail_cleaning_mtm.jpg",
    alt: "에센셜 시그니처 로고 맨투맨 MELANGE GREY",
  },
  {
    id: 4,
    title: "트립 후드 아노락 ORANGE",
    price: 199000,
    imgUrl: "/img/section01_product005_front.jpg",
    imgUrlSub: "/img/section01_product005_back.jpg",
    imgUrlDetail1: "/img/SubImg/section01_product005_detail01.jpg",
    imgUrlDetail2: "/img/SubImg/section01_product005_detail02.jpg",
    imgUrlDetail3: "/img/SubImg/section01_product005_detail03.jpg",
    imgUrlDetail4: "/img/SubImg/section01_product005_detail04.jpg",
    imgUrlDetail5: "",
    imgUrlDetailCleaning: "/img/SubImg/detail_cleaning_mtm.jpg",
    alt: "트립 후드 아노락 ORANGE",
  },
  {
    id: 5,
    title: "트립 리버서블 플리스 자켓 GREEN",
    price: 279000,
    imgUrl: "/img/section01_product006_front.jpg",
    imgUrlSub: "/img/section01_product006_back.jpg",
    imgUrlDetail1: "/img/SubImg/section01_product006_detail01.jpg",
    imgUrlDetail2: "/img/SubImg/section01_product006_detail02.jpg",
    imgUrlDetail3: "/img/SubImg/section01_product006_detail03.jpg",
    imgUrlDetail4: "/img/SubImg/section01_product006_detail04.jpg",
    imgUrlDetail5: "",
    imgUrlDetailCleaning: "/img/SubImg/detail_cleaning_mtm.jpg",
    alt: "트립 리버서블 플리스 자켓 GREEN",
  },
  {
    id: 6,
    title: "에센셜 로고와펜 후드 아노락 IVORY",
    price: 199000,
    imgUrl: "/img/section01_product007_front.jpg",
    imgUrlSub: "/img/section01_product007_back.jpg",
    imgUrlDetail1: "/img/SubImg/section01_product007_detail01.jpg",
    imgUrlDetail2: "/img/SubImg/section01_product007_detail02.jpg",
    imgUrlDetail3: "/img/SubImg/section01_product007_detail03.jpg",
    imgUrlDetail4: "/img/SubImg/section01_product007_detail04.jpg",
    imgUrlDetail5: "",
    imgUrlDetailCleaning: "/img/SubImg/detail_cleaning_mtm.jpg",
    alt: "에센셜 로고와펜 후드 아노락 IVORY",
  },
  {
    id: 7,
    title: "트립 후드 아노락 자켓 우먼 IVORY",
    price: 199000,
    imgUrl: "/img/section01_product008_front.jpg",
    imgUrlSub: "/img/section01_product008_back.jpg",
    imgUrlDetail1: "/img/SubImg/section01_product008_detail01.jpg",
    imgUrlDetail2: "/img/SubImg/section01_product008_detail02.jpg",
    imgUrlDetail3: "/img/SubImg/section01_product008_detail03.jpg",
    imgUrlDetail4: "/img/SubImg/section01_product008_detail04.jpg",
    imgUrlDetail5: "/img/SubImg/section01_product008_detail05.jpg",
    imgUrlDetailCleaning: "/img/SubImg/detail_cleaning_mtm.jpg",
    alt: "트립 후드 아노락 자켓 우먼 IVORY",
  },
  {
    id: 8,
    title: "에센셜 플리스 반집업 맨투맨 BLUE",
    price: 129000,
    imgUrl: "/img/section01_product009_front.jpg",
    imgUrlSub: "/img/section01_product009_back.jpg",
    imgUrlDetail1: "/img/SubImg/section01_product009_detail01.jpg",
    imgUrlDetail2: "/img/SubImg/section01_product009_detail02.jpg",
    imgUrlDetail3: "/img/SubImg/section01_product009_detail03.jpg",
    imgUrlDetail4: "/img/SubImg/section01_product009_detail04.jpg",
    imgUrlDetail5: "",
    imgUrlDetailCleaning: "/img/SubImg/detail_cleaning_mtm.jpg",
    alt: "에센셜 플리스 반집업 맨투맨 BLUE",
  },
  {
    id: 9,
    title: "씨네코닥 피그먼트다잉 맨투맨 IVORY",
    price: 109000,
    imgUrl: "/img/section01_product010_front.jpg",
    imgUrlSub: "/img/section01_product010_back.jpg",
    imgUrlDetail1: "/img/SubImg/section01_product010_detail01.jpg",
    imgUrlDetail2: "/img/SubImg/section01_product010_detail02.jpg",
    imgUrlDetail3: "/img/SubImg/section01_product010_detail03.jpg",
    imgUrlDetail4: "/img/SubImg/section01_product010_detail04.jpg",
    imgUrlDetail5: "",
    imgUrlDetailCleaning: "/img/SubImg/detail_cleaning_mtm.jpg",
    alt: "씨네코닥 피그먼트다잉 맨투맨 IVORY",
  },
  {
    id: 10,
    title: "에센셜 그래픽 맨투맨 MUSTARD",
    price: 119000,
    imgUrl: "/img/section01_product011_front.jpg",
    imgUrlSub: "/img/section01_product011_back.jpg",
    imgUrlDetail1: "/img/SubImg/section01_product011_detail01.jpg",
    imgUrlDetail2: "/img/SubImg/section01_product011_detail02.jpg",
    imgUrlDetail3: "/img/SubImg/section01_product011_detail03.jpg",
    imgUrlDetail4: "/img/SubImg/section01_product011_detail04.jpg",
    imgUrlDetail5: "",
    imgUrlDetailCleaning: "/img/SubImg/detail_cleaning_mtm.jpg",
    alt: "에센셜 그래픽 맨투맨 MUSTARD",
  },
  {
    id: 11,
    title: "트립 피그먼트워싱 세미오버핏 맨투맨 PINK",
    price: 119000,
    imgUrl: "/img/section01_product012_front.jpg",
    imgUrlSub: "/img/section01_product012_back.jpg",
    imgUrlDetail1: "/img/SubImg/section01_product012_detail01.jpg",
    imgUrlDetail2: "/img/SubImg/section01_product012_detail02.jpg",
    imgUrlDetail3: "/img/SubImg/section01_product012_detail03.jpg",
    imgUrlDetail4: "/img/SubImg/section01_product012_detail04.jpg",
    imgUrlDetail5: "/img/SubImg/section01_product012_detail05.jpg",
    imgUrlDetailCleaning: "/img/SubImg/detail_cleaning_mtm.jpg",
    alt: "트립 피그먼트워싱 세미오버핏 맨투맨 PINK",
  },
  {
    id: 12,
    title: "자수로고 스트레이트핏 팬츠 WHITE MELANGE",
    price: 129000,
    imgUrl: "/img/section01_product013_front.jpg",
    imgUrlSub: "/img/section01_product013_back.jpg",
    imgUrlDetail1: "/img/SubImg/section01_product013_detail01.jpg",
    imgUrlDetail2: "/img/SubImg/section01_product013_detail02.jpg",
    imgUrlDetail3: "/img/SubImg/section01_product013_detail03.jpg",
    imgUrlDetail4: "/img/SubImg/section01_product013_detail04.jpg",
    imgUrlDetail5: "",
    imgUrlDetailCleaning: "/img/SubImg/detail_cleaning_mtm.jpg",
    alt: "자수로고 스트레이트핏 팬츠 WHITE MELANGE",
  },
  {
    id: 13,
    title: "스트링 와이드핏 조거 카고 팬츠 GREY",
    price: 169000,
    imgUrl: "/img/section01_product014_front.jpg",
    imgUrlSub: "/img/section01_product014_back.jpg",
    imgUrlDetail1: "/img/SubImg/section01_product014_detail01.jpg",
    imgUrlDetail2: "/img/SubImg/section01_product014_detail02.jpg",
    imgUrlDetail3: "/img/SubImg/section01_product014_detail03.jpg",
    imgUrlDetail4: "/img/SubImg/section01_product014_detail04.jpg",
    imgUrlDetail5: "/img/SubImg/section01_product014_detail05.jpg",
    imgUrlDetailCleaning: "/img/SubImg/detail_cleaning_mtm.jpg",
    alt: "스트링 와이드핏 조거 카고 팬츠 GREY",
  },
  {
    id: 14,
    title: "코어 우븐 테이퍼드 팬츠 KHAKI",
    price: 139000,
    imgUrl: "/img/section01_product015_front.jpg",
    imgUrlSub: "/img/section01_product015_back.jpg",
    imgUrlDetail1: "/img/SubImg/section01_product015_detail01.jpg",
    imgUrlDetail2: "/img/SubImg/section01_product015_detail02.jpg",
    imgUrlDetail3: "/img/SubImg/section01_product015_detail03.jpg",
    imgUrlDetail4: "/img/SubImg/section01_product015_detail04.jpg",
    imgUrlDetail5: "",
    imgUrlDetailCleaning: "/img/SubImg/detail_cleaning_mtm.jpg",
    alt: "코어 우븐 테이퍼드 팬츠 KHAKI",
  },
  {
    id: 15,
    title: "트립 테이퍼드 데님 팬츠 BLUE",
    price: 159000,
    imgUrl: "/img/section01_product016_front.jpg",
    imgUrlSub: "/img/section01_product016_back.jpg",
    imgUrlDetail1: "/img/SubImg/section01_product016_detail01.jpg",
    imgUrlDetail2: "/img/SubImg/section01_product016_detail02.jpg",
    imgUrlDetail3: "/img/SubImg/section01_product016_detail03.jpg",
    imgUrlDetail4: "/img/SubImg/section01_product016_detail04.jpg",
    imgUrlDetail5: "",
    imgUrlDetailCleaning: "/img/SubImg/detail_cleaning_denim.jpg",
    alt: "트립 테이퍼드 데님 팬츠 BLUE",
  },
  {
    id: 16,
    title: "디렉터팩 롱 다운 자켓 BLACK",
    price: 429000,
    imgUrl: "/img/section03_product001_front.jpg",
    imgUrlSub: "/img/section03_product001_back.jpg",
    imgUrlDetail1: "/img/SubImg/section03_product001_detail01.jpg",
    imgUrlDetail2: "/img/SubImg/section03_product001_detail02.jpg",
    imgUrlDetail3: "/img/SubImg/section03_product001_detail03.jpg",
    imgUrlDetail4: "/img/SubImg/section03_product001_detail04.jpg",
    imgUrlDetail5: "",
    imgUrlDetailCleaning: "/img/SubImg/detail_cleaning_padding.jpg",
    alt: "디렉터팩 롱 다운 자켓 BLACK",
  },
  {
    id: 17,
    title: "로고 기모 후드 집업 M.GREY",
    price: 139000,
    imgUrl: "/img/section03_product002_front.jpg",
    imgUrlSub: "/img/section03_product002_back.jpg",
    imgUrlDetail1: "/img/SubImg/section03_product002_detail01.jpg",
    imgUrlDetail2: "/img/SubImg/section03_product002_detail02.jpg",
    imgUrlDetail3: "/img/SubImg/section03_product002_detail03.jpg",
    imgUrlDetail4: "/img/SubImg/section03_product002_detail04.jpg",
    imgUrlDetail5: "",
    imgUrlDetailCleaning: "/img/SubImg/detail_cleaning_mtm.jpg",
    alt: "로고 기모 후드 집업 M.GREY",
  },
  {
    id: 18,
    title: "로고 기모 후드 집업 BLACK",
    price: 139000,
    imgUrl: "/img/section03_product003_front.jpg",
    imgUrlSub: "/img/section03_product003_back.jpg",
    imgUrlDetail1: "/img/SubImg/section03_product003_detail01.jpg",
    imgUrlDetail2: "/img/SubImg/section03_product003_detail02.jpg",
    imgUrlDetail3: "/img/SubImg/section03_product003_detail03.jpg",
    imgUrlDetail4: "/img/SubImg/section03_product003_detail04.jpg",
    imgUrlDetail5: "",
    imgUrlDetailCleaning: "/img/SubImg/detail_cleaning_mtm.jpg",
    alt: "로고 기모 후드 집업 BLACK",
  },
  {
    id: 19,
    title: "로고 기모 후드 집업 우먼 M.GREY",
    price: 139000,
    imgUrl: "/img/section03_product004_front.jpg",
    imgUrlSub: "/img/section03_product004_back.jpg",
    imgUrlDetail1: "/img/SubImg/section03_product004_detail01.jpg",
    imgUrlDetail2: "/img/SubImg/section03_product004_detail02.jpg",
    imgUrlDetail3: "/img/SubImg/section03_product004_detail03.jpg",
    imgUrlDetail4: "/img/SubImg/section03_product004_detail04.jpg",
    imgUrlDetail5: "",
    imgUrlDetailCleaning: "/img/SubImg/detail_cleaning_mtm.jpg",
    alt: "로고 기모 후드 집업 우먼 M.GREY",
  },
  {
    id: 20,
    title: "레인보우 자수 볼캡 RED",
    price: 45000,
    imgUrl: "/img/section04_product001_front.jpg",
    imgUrlSub: "/img/section04_product001_back.jpg",
    imgUrlDetail1: "/img/SubImg/section04_product001_detail01.jpg",
    imgUrlDetail2: "/img/SubImg/section04_product001_detail02.jpg",
    imgUrlDetail3: "/img/SubImg/section04_product001_detail03.jpg",
    imgUrlDetail4: "/img/SubImg/section04_product001_detail04.jpg",
    imgUrlDetail5: "",
    imgUrlDetailCleaning: "/img/SubImg/detail_cleaning_cap.jpg",
    alt: "레인보우 자수 볼캡 RED",
  },
  {
    id: 21,
    title: "레터링 릴렉스핏 볼캡 BLACK",
    price: 45000,
    imgUrl: "/img/section01_product003_front.jpg",
    imgUrlSub: "/img/section01_product003_back.jpg",
    imgUrlDetail1: "/img/SubImg/section01_product003_detail01.jpg",
    imgUrlDetail2: "/img/SubImg/section01_product003_detail02.jpg",
    imgUrlDetail3: "/img/SubImg/section01_product003_detail03.jpg",
    imgUrlDetail4: "/img/SubImg/section01_product003_detail04.jpg",
    imgUrlDetail5: "/img/SubImg/section01_product003_detail05.jpg",
    imgUrlDetailCleaning: "/img/SubImg/detail_cleaning_cap.jpg",
    alt: "레터링 릴렉스핏 볼캡 BLACK",
  },
  {
    id: 22,
    title: "로고 캠프캡 NAVY",
    price: 45000,
    imgUrl: "/img/section04_product003_front.jpg",
    imgUrlSub: "/img/section04_product003_back.jpg",
    imgUrlDetail1: "/img/SubImg/section04_product003_detail01.jpg",
    imgUrlDetail2: "/img/SubImg/section04_product003_detail02.jpg",
    imgUrlDetail3: "/img/SubImg/section04_product003_detail03.jpg",
    imgUrlDetail4: "/img/SubImg/section04_product003_detail04.jpg",
    imgUrlDetail5: "/img/SubImg/section04_product003_detail05.jpg",
    imgUrlDetailCleaning: "/img/SubImg/detail_cleaning_cap.jpg",
    alt: "로고 캠프캡 NAVY",
  },
  {
    id: 23,
    title: "페그 BLACK",
    price: 109000,
    imgUrl: "/img/section04_product004_front.jpg",
    imgUrlSub: "/img/section04_product004_back.jpg",
    imgUrlDetail1: "/img/SubImg/section01_product001_detail01.jpg",
    imgUrlDetail2: "/img/SubImg/section01_product001_detail02.jpg",
    imgUrlDetail3: "/img/SubImg/section01_product001_detail03.jpg",
    imgUrlDetail4: "/img/SubImg/section01_product001_detail04.jpg",
    imgUrlDetail5: "",
    imgUrlDetailCleaning: "/img/SubImg/detail_cleaning_shoes.jpg",
    alt: "페그 BLACK",
  },
  {
    id: 24,
    title: "레티나 W.BLACK",
    price: 129000,
    imgUrl: "/img/section04_product005_front.jpg",
    imgUrlSub: "/img/section04_product005_back.jpg",
    imgUrlDetail1: "/img/SubImg/section04_product005_detail01.jpg",
    imgUrlDetail2: "/img/SubImg/section04_product005_detail02.jpg",
    imgUrlDetail3: "/img/SubImg/section04_product005_detail03.jpg",
    imgUrlDetail4: "/img/SubImg/section04_product005_detail04.jpg",
    imgUrlDetail5: "",
    imgUrlDetailCleaning: "/img/SubImg/detail_cleaning_shoes.jpg",
    alt: "레티나 W.BLACK",
  },
  {
    id: 25,
    title: "코다크롬 PINK",
    price: 149000,
    imgUrl: "/img/section04_product006_front.jpg",
    imgUrlSub: "/img/section04_product006_back.jpg",
    imgUrlDetail1: "/img/SubImg/section04_product006_detail01.jpg",
    imgUrlDetail2: "/img/SubImg/section04_product006_detail02.jpg",
    imgUrlDetail3: "/img/SubImg/section04_product006_detail03.jpg",
    imgUrlDetail4: "/img/SubImg/section04_product006_detail04.jpg",
    imgUrlDetail5: "/img/SubImg/section04_product006_detail05.jpg",
    imgUrlDetailCleaning: "/img/SubImg/detail_cleaning_shoes.jpg",
    alt: "코다크롬 PINK",
  },
  {
    id: 26,
    title: "에센셜 스퀘어 미니 크로스백 BLACK",
    price: 59000,
    imgUrl: "/img/section04_product007_front.jpg",
    imgUrlSub: "/img/section04_product007_back.jpg",
    imgUrlDetail1: "/img/SubImg/section04_product007_detail01.jpg",
    imgUrlDetail2: "/img/SubImg/section04_product007_detail02.jpg",
    imgUrlDetail3: "/img/SubImg/section04_product007_detail03.jpg",
    imgUrlDetail4: "/img/SubImg/section04_product007_detail04.jpg",
    imgUrlDetail5: "/img/SubImg/section04_product007_detail05.jpg",
    imgUrlDetailCleaning: "/img/SubImg/detail_cleaning_bag.jpg",
    alt: "에센셜 스퀘어 미니 크로스백 BLACK",
  },
  {
    id: 27,
    title: "포켓 미니 크로스백 ORANGE",
    price: 89000,
    imgUrl: "/img/section04_product008_front.jpg",
    imgUrlSub: "/img/section04_product008_back.jpg",
    imgUrlDetail1: "/img/SubImg/section04_product008_detail01.jpg",
    imgUrlDetail2: "/img/SubImg/section04_product008_detail02.jpg",
    imgUrlDetail3: "/img/SubImg/section04_product008_detail03.jpg",
    imgUrlDetail4: "/img/SubImg/section04_product008_detail04.jpg",
    imgUrlDetail5: "/img/SubImg/section04_product008_detail05.jpg",
    imgUrlDetailCleaning: "/img/SubImg/detail_cleaning_bag.jpg",
    alt: "포켓 미니 크로스백 ORANGE",
  },
  {
    id: 28,
    title: "라지 보스턴백 PURPLE",
    price: 159000,
    imgUrl: "/img/section04_product009_front.jpg",
    imgUrlSub: "/img/section04_product009_back.jpg",
    imgUrlDetail1: "/img/SubImg/section04_product009_detail01.jpg",
    imgUrlDetail2: "/img/SubImg/section04_product009_detail02.jpg",
    imgUrlDetail3: "/img/SubImg/section04_product009_detail03.jpg",
    imgUrlDetail4: "/img/SubImg/section04_product009_detail04.jpg",
    imgUrlDetail5: "/img/SubImg/section04_product009_detail05.jpg",
    imgUrlDetailCleaning: "/img/SubImg/detail_cleaning_bag.jpg",
    alt: "라지 보스턴백 PURPLE",
  },
  {
    id: 29,
    title: "[SET] 코다컬러 트랙 집업 자켓 & 팬츠 BURGUNDY",
    price: 338000,
    imgUrl: "/img/section02_product001_front.jpg",
    imgUrlSub: "/img/section02_product001_back.jpg",
    imgUrlDetail1: "/img/SubImg/section02_product001_detail01.jpg",
    imgUrlDetail2: "/img/SubImg/section02_product001_detail02.jpg",
    imgUrlDetail3: "/img/SubImg/section02_product001_detail03.jpg",
    imgUrlDetail4: "/img/SubImg/section02_product001_detail04.jpg",
    imgUrlDetail5: "/img/SubImg/section02_product001_detail05.jpg",
    imgUrlDetailCleaning: "/img/SubImg/detail_cleaning_mtm.jpg",
    alt: "[SET] 코다컬러 트랙 집업 자켓 & 팬츠 BURGUNDY",
  },
  {
    id: 30,
    title: "코다컬러 벨벳 코듀로이 집업 자켓 키즈 MINT GREEN",
    price: 149000,
    imgUrl: "/img/section02_product002_front.jpg",
    imgUrlSub: "/img/section02_product002_back.jpg",
    imgUrlDetail1: "/img/SubImg/section02_product002_detail01.jpg",
    imgUrlDetail2: "/img/SubImg/section02_product002_detail02.jpg",
    imgUrlDetail3: "/img/SubImg/section02_product002_detail03.jpg",
    imgUrlDetail4: "/img/SubImg/section02_product002_detail04.jpg",
    imgUrlDetail5: "/img/SubImg/section02_product002_detail05.jpg",
    imgUrlDetailCleaning: "/img/SubImg/detail_cleaning_mtm.jpg",
    alt: "코다컬러 벨벳 코듀로이 집업 자켓 키즈 MINT GREEN",
  },
  {
    id: 31,
    title: "로고 기모 후드 집업 우먼 BLACK",
    price: 139000,
    imgUrl: "/img/section03_product005_front.jpg",
    imgUrlSub: "/img/section03_product005_back.jpg",
    imgUrlDetail1: "/img/SubImg/section03_product005_detail01.jpg",
    imgUrlDetail2: "/img/SubImg/section03_product005_detail02.jpg",
    imgUrlDetail3: "/img/SubImg/section03_product005_detail03.jpg",
    imgUrlDetail4: "/img/SubImg/section03_product005_detail04.jpg",
    imgUrlDetail5: "",
    imgUrlDetailCleaning: "/img/SubImg/detail_cleaning_mtm.jpg",
    alt: "로고 기모 후드 집업 우먼 BLACK",
  },
  {
    id: 32,
    title: "에센셜 스텐넥 숏 다운 자켓 BLACK",
    price: 319000,
    imgUrl: "/img/section03_product006_front.jpg",
    imgUrlSub: "/img/section03_product006_back.jpg",
    imgUrlDetail1: "/img/SubImg/section03_product006_detail01.jpg",
    imgUrlDetail2: "/img/SubImg/section03_product006_detail02.jpg",
    imgUrlDetail3: "/img/SubImg/section03_product006_detail03.jpg",
    imgUrlDetail4: "/img/SubImg/section03_product006_detail04.jpg",
    imgUrlDetail5: "",
    imgUrlDetailCleaning: "/img/SubImg/detail_cleaning_padding.jpg",
    alt: "에센셜 스텐넥 숏 다운 자켓 BLACK",
  },
  {
    id: 33,
    title: "레인보우 다운 자켓 BLACK",
    price: 329000,
    imgUrl: "/img/section03_product007_front.jpg",
    imgUrlSub: "/img/section03_product007_back.jpg",
    imgUrlDetail1: "/img/SubImg/section03_product007_detail01.jpg",
    imgUrlDetail2: "/img/SubImg/section03_product007_detail02.jpg",
    imgUrlDetail3: "/img/SubImg/section03_product007_detail03.jpg",
    imgUrlDetail4: "/img/SubImg/section03_product007_detail04.jpg",
    imgUrlDetail5: "",
    imgUrlDetailCleaning: "/img/SubImg/detail_cleaning_padding.jpg",
    alt: "레인보우 다운 자켓 BLACK",
  },
  {
    id: 34,
    title: "레인보우 다운 자켓 GREEN",
    price: 329000,
    imgUrl: "/img/section03_product008_front.jpg",
    imgUrlSub: "/img/section03_product008_back.jpg",
    imgUrlDetail1: "/img/SubImg/section03_product008_detail01.jpg",
    imgUrlDetail2: "/img/SubImg/section03_product008_detail02.jpg",
    imgUrlDetail3: "/img/SubImg/section03_product008_detail03.jpg",
    imgUrlDetail4: "/img/SubImg/section03_product008_detail04.jpg",
    imgUrlDetail5: "",
    imgUrlDetailCleaning: "/img/SubImg/detail_cleaning_padding.jpg",
    alt: "레인보우 다운 자켓 GREEN",
  },
  {
    id: 35,
    title: "레인보우 다운 자켓 IVORY",
    price: 329000,
    imgUrl: "/img/section03_product009_front.jpg",
    imgUrlSub: "/img/section03_product009_back.jpg",
    imgUrlDetail1: "/img/SubImg/section03_product009_detail01.jpg",
    imgUrlDetail2: "/img/SubImg/section03_product009_detail02.jpg",
    imgUrlDetail3: "/img/SubImg/section03_product009_detail03.jpg",
    imgUrlDetail4: "/img/SubImg/section03_product009_detail04.jpg",
    imgUrlDetail5: "/img/SubImg/section03_product009_detail05.jpg",
    imgUrlDetailCleaning: "/img/SubImg/detail_cleaning_padding.jpg",
    alt: "레인보우 다운 자켓 IVORY",
  },
  {
    id: 36,
    title: "에센셜 테이퍼드 카고 팬츠 우먼 IVORY",
    price: 139000,
    imgUrl: "/img/section03_product010_front.jpg",
    imgUrlSub: "/img/section03_product010_back.jpg",
    imgUrlDetail1: "/img/SubImg/section03_product010_detail01.jpg",
    imgUrlDetail2: "/img/SubImg/section03_product010_detail02.jpg",
    imgUrlDetail3: "/img/SubImg/section03_product010_detail03.jpg",
    imgUrlDetail4: "/img/SubImg/section03_product010_detail04.jpg",
    imgUrlDetail5: "",
    imgUrlDetailCleaning: "/img/SubImg/detail_cleaning_pants.jpg",
    alt: "에센셜 테이퍼드 카고 팬츠 우먼 IVORY",
  },
  {
    id: 37,
    title: "로고 캐시미어 바라클라바 IVORY",
    price: 99000,
    imgUrl: "/img/section03_product011_front.jpg",
    imgUrlSub: "/img/section03_product011_back.jpg",
    imgUrlDetail1: "/img/SubImg/section03_product011_detail01.jpg",
    imgUrlDetail2: "/img/SubImg/section03_product011_detail02.jpg",
    imgUrlDetail3: "/img/SubImg/section03_product011_detail03.jpg",
    imgUrlDetail4: "/img/SubImg/section03_product011_detail04.jpg",
    imgUrlDetail5: "",
    imgUrlDetailCleaning: "/img/SubImg/detail_cleaning_cap.jpg",
    alt: "로고 캐시미어 바라클라바 IVORY",
  },
  {
    id: 38,
    title: "가든 라벨 핸드워머 IVORY",
    price: 45000,
    imgUrl: "/img/section03_product012_front.jpg",
    imgUrlSub: "/img/section03_product012_back.jpg",
    imgUrlDetail1: "/img/SubImg/section03_product012_detail01.jpg",
    imgUrlDetail2: "/img/SubImg/section03_product012_detail02.jpg",
    imgUrlDetail3: "/img/SubImg/section03_product012_detail03.jpg",
    imgUrlDetail4: "/img/SubImg/section03_product012_detail04.jpg",
    imgUrlDetail5: "",
    imgUrlDetailCleaning: "/img/SubImg/detail_cleaning_mtm.jpg",
    alt: "가든 라벨 핸드워머 IVORY",
  },
];

export default data;
